<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    洪浪北站<br><br>
站点介绍<br>
车站位于创业二路和新安三路交汇处地下，沿创业二路布置，呈西南至东北走向。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:10	23:55	5号线	3分钟	5分25秒<br>
黄贝岭	06:25	23:26	5号线	3分钟	5分25秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:06	23:55	5号线	4分钟	6分钟<br>
黄贝岭	06:32	23:26	5号线	4分钟	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:06	00:55	5号线	4分钟	6分钟<br>
黄贝岭	06:32	00:26	5号线	4分钟	6分钟<br><br>

站点出口信息<br>
A出入口:<br>
创业二路南侧(西)、新安二路、洪浪北路、勤诚达·前海世界、灵芝小学、勤诚达K+广场<br><br>
B出入口:<br>
创业二路南侧(东)、大宝路南侧、大浪社区健康服务中心、丰华苑、宝雅花园、海关大厦、东联工业区<br><br>
C出入口:<br>
新安三路北侧、上合社区居委会、大浪社区居委会、新丰小学<br><br>
D出入口:<br>
创业二路北侧、冠华育才学校<br><br>
公交换乘信息<br>
A出入口:<br>
公交站名： 洪浪北地铁站<br>
M395、610、629、866、B829、M182、M245、M246、M313、M377、M378、M393、高峰专线56（原M586）<br><br>
B出入口:<br>
公交站名： 新安税务<br>
610、615、629、866、B829、M182、M313、M376、M377、M378、M379、M382、M393、M395、M206、M522、M560、高峰专线56（原M586）、B904社区微巴<br><br>
C出入口:<br>
公交站名： 新安交警中队<br>
605、M246、M259、M376、M379、M382、M522、M550、M553、M560<br><br>
D出入口:<br>
公交站名： 洪浪北地铁站<br>
629、M245、M246、M313、M377、M378、M393、M395、B829、高峰专线56（原M586）<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "wuhaoxian",
          title: "5号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>


